
type FunctionAsString = string;

export interface EvalFunctionWorkerMessage {
  dependentFunctions: FunctionAsString[];
  evaluatedFunction: FunctionAsString;
  evaluatedFunctionArgs: unknown[];
}

function createWorker<T>(fn: (e: MessageEvent<T>) => void) {
  const blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });
  const url = URL.createObjectURL(blob);

  return new Worker(url);
}

/**
 * evalFunctionWorker
 * Generic web worker that evaluate a given function with given arguments
 *
 * postMessage message object paramaters:
 * dependentFunctions: list of functions as strings that will be evaluated to be part of the web worker scope
 * evaluatedFunction: function as string that will be evaluated and called with arguments
 * evaluatedFunctionArgs: arguments that will be passed to the evaluated function
 */
export function evalFunctionWorker() {
  const worker = createWorker<EvalFunctionWorkerMessage>((e) => {
    // Evaluate all dependencies to bring them into the web worker scope
    // (all functions that you evaluated function might call)
    // Then, evaluate the function that will be called
     
    const evaluatedFunction = new Function(
      `${e.data.dependentFunctions.join('')}; return ${e.data.evaluatedFunction}`,
    )();

    // Note: within a Worker/Blob method names are lost during minification when using the spread operator, use method.apply instead
     
    const output = evaluatedFunction.apply(Object, e.data.evaluatedFunctionArgs);

    // Return the output
    self.postMessage(output);
  });

  worker.onerror = (e) => {
    console.info('web worker error: ', e);
  };

  return worker;
}
